import { ContainerSize, HTML } from '@lib/types';
import Container from '@components/container';

export type HTMLSectionProps = {
  data: HTML;
};

export default function HTMLSection({ data: { html } }: HTMLSectionProps) {
  return (
    <Container size={ContainerSize.wide}>
      <div className="grid grid-cols-12 gap-1.5 md:gap-6">
        <div className="col-start-2 col-span-10 lg:col-start-4 lg:col-span-6">
          <div
            className="flex justify-center"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </Container>
  );
}
